/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StartBatchContactImportResponseContent
 */
export interface StartBatchContactImportResponseContent {
    /**
     * 
     * @type {string}
     * @memberof StartBatchContactImportResponseContent
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof StartBatchContactImportResponseContent
     */
    contactImportId?: string;
}


/**
 * Check if a given object implements the StartBatchContactImportResponseContent interface.
 */
export function instanceOfStartBatchContactImportResponseContent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StartBatchContactImportResponseContentFromJSON(json: any): StartBatchContactImportResponseContent {
    return StartBatchContactImportResponseContentFromJSONTyped(json, false);
}

export function StartBatchContactImportResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartBatchContactImportResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
        'contactImportId': !exists(json, 'contactImportId') ? undefined : json['contactImportId'],
    };
}

export function StartBatchContactImportResponseContentToJSON(value?: StartBatchContactImportResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'contactImportId': value.contactImportId,
    };
}

